import { checkoutUserErrorFragment } from './fragmentGeneral.gql';

/*
The fields used to create a customer access token.
input ( CustomerAccessTokenCreateInput! ) required

	email (String!) Required
	The email associated to the customer.

	password (String!) Required
	The login password to be used by the customer.
*/


const accountLogin = (
	`mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
		customerAccessTokenCreate(input: $input) {
			customerAccessToken {
				accessToken
      	expiresAt
			}
			customerUserErrors ${checkoutUserErrorFragment}
		}
	}`
);

export default accountLogin;
